import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useQueryParams } from "../useQueryParams";
import { setUTMParams } from "../../store/reducers/utm";

export const useSaveUTMParams = () => {
  const dispatch = useDispatch();
  const query = useQueryParams();

  useEffect(() => {
    const utmParams: Record<string, string> = {};

    query.forEach((value, key) => {
      if (key.startsWith("utm_") || key === "affid") {
        utmParams[key] = value;
      }
    });

    if (Object.keys(utmParams).length > 0) {
      dispatch(setUTMParams(utmParams));
    }
  }, [dispatch, query]);
};
